// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ht1q","content":"styles_content__4vMAM"};